<template>
  <div class="report-ve-awards">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="alert alert-info">
          <button type="button" class="btn btn-primary float-right showHideBtn" v-b-toggle.filterControls v-on:click="showHideFilters()" title="Show/Hide Filters" v-b-tooltip.hover>
            <span v-html="showHideFilterText"></span>
          </button>
          <div class="mr-2 float-right">
            Download current view as:
            <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
            </button>
            <button type="button" class="btn btn-link p-0" v-on:click="exportToPDF()">
              <i class="fas fa-file-pdf fa-fw fa-2x" title="Download as a PDF document" v-b-tooltip.hover></i>
            </button>
          </div>
          <h4 class="alert-heading">Filtered Search</h4>
          <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
            <hr>
            <div class="row">
              <div class="col-sm-4 mb-2">
                <label>Nomination Category</label>
                <select v-model="nominationCategorySelect" v-on:change="loadNominations()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in nominationCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
              <div class="col-sm-4 mb-2">
                <label>Community</label>
                <select v-model="communityCategorySelect" v-on:change="loadNominations()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in communityCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 mb-2">
                <label for="nominatorFilter">From Date:</label>
                <div class="input-group">
                  <input type="date" ref="fromDate" name="fromDate" id="fromDate" :value="fromDate" v-on:change="loadNominations()" />
                </div>
              </div>
              <div class="col-sm-3 mb-2">
                <label for="nomineeFilter">To Date:</label>
                <input type="date" ref="toDate" name="toDate" id="toDate" :value="toDate" v-on:change="loadNominations()" />
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="row" id="nominations">
          <div class="col-sm-3">
            <div class="alert alert-primary text-center" role="alert">
              Nominations: {{totalPosts}}
            </div>
          </div>
        </div>
        <InnovationReportEntries v-if="nominations.length > 0" :nominations="nominations"></InnovationReportEntries>
        <span v-if="nominations.length === 0">
          No nominations have been submitted
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Items per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadNominations()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="500">500</option>
                <option :value="1000">1000</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <iframe id="iFramePdf" src="myPdfUrl.pdf" style="display:none;"></iframe>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import InnovationReportEntries from '@/components/InnovationReportEntries'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader,
    InnovationReportEntries
  },
  data () {
    return {
      nominations: [],
      contentReady: false,
      contentLoadError: '',
      graduatedNominationsCheck: false,
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      nominatorFilter: '',
      nominatorFilterButton: '+',
      nomineeFilter: '',
      nomineeFilterButton: '+',
      showHideFilterText: '<i class="fas fa-angle-up"></i>',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 100,
      toDate: '',
      fromDate: ''
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('nomination_event_category?per_page=100&parent=105')
      .then(response => {
        this.nominationCategories = response.data.filter(x => x.id !== 22 && x.id !== 35 && x.id !== 21)
        this.nominationCategorySelect = this.$route.query.cat
      })
      .catch(e => {
        console.error(e)
      })
    WordpressRestAPI.getViewContent('community_categories?per_page=100')
      .then(response => {
        this.communityCategories = response.data
      })
      .catch(e => {
        console.error(e)
      })
    this.loadNominations()
  },
  methods: {
    exportToPDF: function () {
      window.print()
    },
    validateDates: function() {
      if (this.$refs.toDate)
        this.toDate = this.$refs.toDate.value

      if (this.$refs.fromDate)
        this.fromDate = this.$refs.fromDate.value


      if ( this.toDate !== '' && this.fromDate !== '' ) {
        return '&after=' + this.fromDate + ' 00:00:00&before=' + this.toDate + ' 23:59:59'
      }
      return ''
    },
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/�/g, '\'').replace(/�/g, '"').replace(/�/g, '"')
          exportData[header] = value
        }
      })
      return exportData
    },
    exportToCSV: function () {
        var self = this
        // Map fields of nominations array that will be converted to CSV
        const items = this.nominations.map(function (x) {
        console.log('x', x)
        // Initialize empty arrays to store the extracted data
        const nomineeNames = []
        const nomineeEmployeeNumbers = []
        const nomineeEmails = []
        const GOM = []
        const BU = []
        const Country = []
        if (x.innovation_awards_nominee && x.innovation_awards_nominee[0] && x.innovation_awards_nominee[0][0]) {
            console.log(' x.innovation_awards_nominee[0][0] ', x.innovation_awards_nominee[0][0])
            // Iterate through the innovation_awards_nominee array
            x.innovation_awards_nominee[0][0].forEach(record => {
              console.log('record ', record)
              nomineeNames.push(record.innovation_nominee_name)
              nomineeEmployeeNumbers.push(record.innovation_employee_number)
              nomineeEmails.push(record.innovation_nominee_email)
              if (record.employeehierarchy) {
                GOM.push(record.employeehierarchy.gom[0])
                BU.push(record.employeehierarchy.businessunit[0])
                Country.push(record.employeehierarchy.country[0])
              } else {
                GOM.push('Not Found')
                BU.push('Not Found')
                Country.push('Not Found')
              }
            });
        }
        var splitData = {}
        //console.log('row12-> id ',x.innovation_awards_nominee[0], x.innovation_awards_nominee[0][0].length)
        if (x.innovation_nominationdata.length) {
          splitData = self.exportContentData(x.innovation_nominationdata)
        }

        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.innovation_nominator_employee_number,
          Nominee_Name: nomineeNames,
          Nominee_Employee_Number: nomineeEmployeeNumbers,
          Nominee_Email: nomineeEmails,
          GOM: GOM,
          BU: BU,
          Country: Country,
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1]
        },splitData)
        return temp
      })
      // FILL MISSING HEADER ROWS
      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }
      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
      console.log(" 279 csvKeys ", csvKeys)
      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (!items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = ''
          }
        }
      }
      console.log(' 287 ', items)
      ExportToCSV.createCSV(items, 'InnovationAwards',false, false)
    },
    exportToCSV1: function () {
      var self = this
      // Map fields of nominations array that will be converted to CSV
      const items = this.nominations.map(function (x) {
        var splitData = {}
        if (x.innovation_nominationdata.length) {
          splitData = self.exportContentData(x.innovation_nominationdata)
        }
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.innovation_nominator_employee_number,
          Nominee_Name: x.innovation_nominee_name[0],
          Nominee_Employee_Number: x.innovation_employee_number[0],
          Nominee_Email: x.innovation_nominee_email[0],
          GOM: x.innovation_nominee_email.employeehierarchy.gom[0],
          BU: x.innovation_nominee_email.employeehierarchy.businessunit[0],
          Country: x.innovation_nominee_email.employeehierarchy.country[0],
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1]
        }, splitData)
        return temp
      })

      // FILL MISSING HEADER ROWS
      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }
      ExportToCSV.createCSV(items, 'InnovationAwards')
    },
    showHideFilters: function () {
      if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
        this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
      } else {
        this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
      }
    },
    generateSearchQuery: function () {
      let ideaCatFilter = ''
      let communityFilter = ''
      // let authorFilter = ''
      if (this.nominationCategorySelect !== '-- All --' && this.nominationCategorySelect !== undefined) {
        ideaCatFilter = '&nomination_event_category=' + this.nominationCategorySelect
      }
      if (this.communityCategorySelect !== '-- All --') {
        communityFilter = '&community_categories=' + this.communityCategorySelect
      }
      return '?_embed' + ideaCatFilter + communityFilter // + authorFilter
    },
    loadNominations: function () {
      this.contentReady = false
      WordpressRestAPI.getViewContent('innovation_awards' + this.generateSearchQuery() + '&page=' + this.currentPage + '&custom_per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.nominations = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadNominations()
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/ReportInnovationAwards.vue